import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import logoimg from '../../assets/MK1.3.png';
import senddata from "../../Data/data.js";
import sendFormData from "../../Data/formData.js";
import test from "../../assets/test.png";
// 25/7
import { io } from "socket.io-client";

function Course() {
    const location = useLocation();
    var course = location.state;
    const navigate = useNavigate();

    // 25/7
    const socketRef = useRef();
    
    const fileInputRef = useRef(null);

    const [refresh,setRefresh] = useState(false);
    const [refresh1,setRefresh1] = useState(false);
    const [refresh2,setRefresh2] = useState(false);
    const [showOptions,setShowOptions] = useState(1);

    const [enableEdit,setEnableEdit] = useState(false);
    const [enableAddv,setEnableAddv] = useState(false);
    const [enableEditv,setenableEditv] = useState(false);
    const [enableAddf,setEnableAddf] = useState(false);

    const [title,setTitle] = useState(course.title);
    const [price,setPrice] = useState(course.price);
    const [subject,setSubject] = useState(course.subject);
    const [level,setLevel] = useState(course.level);
    const [departement,setDepartement] = useState(course.level);
    // 25/7
    const [hide, setHide] = useState(course.hide);
    const [availableTime, setAvailableTime] = useState(course.availableTime || 0);
    // try
    const [messageText, setMessageText] = useState("");

    const [selectlevel,setSelectlevel] = useState(course.level+"-"+course.departement);

    const [name,setName] = useState("");
    const [year,setYear] = useState("one-sec");
    const [lec,setLec] = useState("");
    const [file,setFile] = useState("");

    const [allVideos,setAllVideos] = useState(course.videoslist);
    const [allFiles,setFiles] = useState([]);
    const [allCodes,setAllCodes] = useState([]);
    const [usedCodes,setUsedCodes] = useState([]);
    const [allExams,setAllexams] = useState([]);
    // 25/7
    const [allStudentScore,setAllStudentScore] = useState([]);
    const [liveVideo,setLiveVideo] = useState("");
    const [liveMessages, setLiveMessages] = useState([]);

    // 25/8
    const [enableAddImage, setEnableAddImage] = useState(false);
    const [groupName, setGroupName] = useState('');
    const [selectedImages, setSelectedImages] = useState([]);
    const [imageGroups, setImageGroups] = useState([]);
    const imageInputRef = useRef();


    const [videoId,setVideoId] = useState("");
    const [type,setType] = useState("free");
    const [description,setDescription] = useState("");


    useEffect(()=>{
      if(selectlevel=="six-pri"){
        setLevel("six")
        setDepartement("pri");
      } else if(selectlevel=="one-pre"){
        setLevel("one")
        setDepartement("pre");
      } if(selectlevel=="two-pre"){
        setLevel("two")
        setDepartement("pre");
      } if(selectlevel=="three-pre"){
        setLevel("three")
        setDepartement("pre");
      } if(selectlevel=="one-sec"){
        setLevel("one")
        setDepartement("sec");
      }
      if(selectlevel=="two-sec"){
        setLevel("two")
        setDepartement("sec");
      }
      if(selectlevel=="three-sec"){
        setLevel("three")
        setDepartement("sec");
      }
    },[selectlevel])


    useEffect(()=>{
      getAllVideos()
    },[refresh])

    useEffect(()=>{
      if (!allCodes.length&&showOptions==2){
        getAllCodes();
      }
      if (!allFiles.length&&showOptions==5){
        getAllFiles();
        fetchAllImages();
      }
      if (!allExams.length&&showOptions==3){
        getallExams();
      }
      if (!allStudentScore.length&&showOptions==6){
        getallScores();
      }

    },[showOptions]);

    // 25/7
    useEffect(() => {
      if (showOptions !== 7) return;

      socketRef.current.emit("joinLive", course._id);

      socketRef.current.on("chatHistory", (history) => {
        setLiveMessages(history);
      });

      socketRef.current.on("receiveMessage", (msg) => {
        setLiveMessages(prev => [...prev, msg]);
      });

      socketRef.current.on("messageDeleted", (msgId) => {
        setLiveMessages(prev => prev.filter(m => m.id !== msgId));
      });

      return () => {
        socketRef.current.off("chatHistory");
        socketRef.current.off("receiveMessage");
        socketRef.current.off("messageDeleted");
      };
    }, [showOptions]);

    useEffect(() => {
      socketRef.current = io("https://atia.genuisweb.com", {
        transports: ["polling", "websocket"], // دعم fallback
        withCredentials: false,
        reconnection: true,
      });

      socketRef.current.on("connect", () => {
        console.log("✅ Socket connected with ID:", socketRef.current.id);
      });

      socketRef.current.on("disconnect", () => {
        console.log("❌ Socket disconnected");
      });

      return () => {
        socketRef.current.disconnect();
      };
    }, []);

    // 25/7
    const deleteMessage = (messageId) => {
      socketRef.current.emit("deleteMessage", { courseId: course._id, messageId });
    };


    const getAllCodes =()=>{
      senddata(`course/getcodes/${course._id}`,{}, "GET").then((res) => {
        if (res.status !== 200) {
          alert('ادخل بيانات صحيحة ');
        } else {
          setAllCodes(res.data);
        }
        });
    }

    const createCodes =()=>{
      senddata(`course/createcode/${course._id}`,{}, "PUT").then((res) => {
        if (res.status !== 200) {
          alert('تأكد من الاتصال بالانترنت ');
        } else {
          getAllCodes();
        }
        });
    }

    // 25/7
    const saveInfo =()=>{
      const data ={...course,price,title,subject,level,departement,hide,availableTime}
      senddata(`course/editcourse/${course._id}`,data, "PATCH").then((res) => {
        if (res.status !== 200) {
          alert('ادخل بيانات صحيحة ');
        } else {
          alert('تم تعديل الكورس بنجاح ');
          setEnableEdit(false)
        }
        });
    }

    const addVideo =()=>{
      const data ={videoId,type,description}
      senddata(`video/download-video/${course._id}`,data, "PUT").then((res) => {
        if (res.status !== 200) {
          alert('ادخل بيانات صحيحة ');
        } else {
          alert('تم اضافة فيديو بنجاح ');
          setRefresh(!refresh);
        }
        });
    }

    const editVideo =()=>{
      console.log("")
    }

    const deleteVideo =(id)=>{
      const userResponse = prompt(`امتب Ok لتأكيد حذف السؤال `);
      if(userResponse?.trim() =="ok" ){
        senddata(`video/deletevideo/${course._id}/${id}`,{}, "DELETE").then((res) => {
          if (res.status !== 200) {
            alert('تأكد من الاتصال بالانترنت');
          } else {
            alert('تم حذف الفديو  ');
            setRefresh(!refresh);
          }
          });
      }else{
        alert("لم يتم حذف الفيديو")
      }
    }

    const getAllVideos =()=>{
      senddata(`video/getvideos/${course._id}`,{}, "GET").then((res) => {
        if (res.status !== 200) {
          alert('تأكد من الاتصال بالانترنت ');
        } else {
          setAllVideos(res.data);
        }
        });
    }

    const addFile =()=>{
      if (file&&name){
        let data = new FormData();
        data.append('name', name);
        data.append('year', year);
        data.append('lec', lec);
        data.append('file',file );

        sendFormData(`pdf/teacher/upload_pdf/${course._id}`,data, "POST").then((res) => {
          if (res.status !== 200) {
            alert('تأكد من البيانات');
          } else {
            alert("تم اضافة الملف ");
            getAllFiles();
          }
          });
        }else {
          alert("ادخل البيانات")
        }
    }

    const getAllFiles =()=>{
      senddata(`pdf/both/get_pdfs/${course._id}`,{}, "GET").then((res) => {
        if (res.status !== 200) {
          alert('تأكد من الاتصال بالانترنت ');
        } else {
          setFiles(res.data);
        }
        });
    }

    const openPdf =(file)=>{
      window.open(file.pdf, "_blank", "noopener,noreferrer");
    }

    const deletePdf =(file)=>{
      const userResponse = prompt(`اكتب Ok لتأكيد حذف الملف `);
      if(userResponse?.trim() =="ok" ){
        senddata(`pdf/teacher/delete_pdf/${file._id}`,{}, "DELETE").then((res) => {
          if (res.status !== 200) {
            alert('تأكد من الاتصال بالانترنت');
          } else {
            alert('تم حذف الملف  ');
            getAllFiles();
          }
          });
      }else{
        alert("لم يتم حذف الملف");
      }
    }

    const handleFileChange = (e) => {
      const newfile = e.target.files[0];
      if (newfile) {
          const validImageTypes = ["application/pdf"];
          if (!validImageTypes.includes(newfile.type)) {
            alert("ادخل pdf ")
            return;
        }
          setFile(newfile)
      }else {
        setFile("");
      }
    };

    const habdleExercise =()=>{
      localStorage.setItem("courseid_for_course_exam",course._id);
      localStorage.setItem("courselevel_for_course_exam",course.level);
      localStorage.setItem("coursedep_for_course_exam",course.departement);
      localStorage.setItem("coursename_for_course_exam",course.title);
      navigate("/examincourse");
    }

    // exams

    const getallExams =()=>{
      senddata(`teacher/exam/get_exams_incourse/${course._id}`,{}, "GET").then((res) => {
        if (res.status !== 200) {
          alert('تأكد من الاتصال بالانترنت');
        } else {
          setAllexams(res.data)
        }
        });
    }

    const deleteExam =(exam)=>{
      const id =exam._id
      if(exam.title=="exerciseinvideo"){
        alert("لا يمكن حذف الامتحان");
        return;
      }
      const userResponse = prompt(`اكتب ok لتأكيد حذف الامتحان `);
      if(userResponse?.trim() =="ok" ){
      senddata(`teacher/exam/delete_exam/${id}`,{}, "Delete").then((res) => {
        if (res.status !== 200) {
        alert('تأكد من الاتصال من الانترنت ');
        } else {
          alert('تم مسح الامتحان بنجاح  ');
          getallExams();
        }
        });
      }else{
        alert("لم يتم حذف الامتحان ")
      }
    }

    // usedcodes

    const handleUsedCodes =()=>{
      senddata(`student/course/getUsedCodesDetails/${course._id}`,{}, "GET").then((res) => {
        if (res.status !== 200) {
          alert('تأكد من الاتصال بالانترنت');
        } else {
          setUsedCodes(res.data)
          navigate("/usedCodes",{ state: {usedCodes:res.data} });
        }
        });
    }

    // 25/7
    // score
    const getallScores =()=>{
      senddata(`course_score/all/${course._id}`,{}, "GET").then((res) => {
        if (res.status !== 200) {
          alert('تأكد من الاتصال بالانترنت');
        } else {
          setAllStudentScore(res.data)
        }
        });
    }



    const addLive =()=>{
      const extractYouTubeLiveId = (inputUrl) => {
        try {
          const urlObj = new URL(inputUrl);
          if (urlObj.hostname === "youtube.com" || urlObj.hostname === "www.youtube.com") {
            if (urlObj.pathname.startsWith("/live/")) {
              const id = urlObj.pathname.split("/live/")[1];
              return id || null;
            }
          }
          return null;
        } catch (error) {
          console.error("Invalid URL:", error);
          return null;
        }
      };
      const liveVideoId = extractYouTubeLiveId(liveVideo);

      if (liveVideoId){
        const data ={live_video:liveVideoId}
        senddata(`course/add_live_link/${course._id}`,data, "POST").then((res) => {
          if (res.status !== 200) {
            alert('ادخل بيانات صحيحة ');
          } else {
            alert('تم اضافة الايف بنجاح ');
          }
          });
      } else {
        alert('ادخل بيانات صحيحة ');
      }

    }

    const deleteLive = ()=>{
      senddata(`course/delete_live_link/${course._id}`,{} ,"delete").then((res) => {
        if (res.status !== 200) {
          alert('حدث خطأ ');
        } else {
          alert('تم انهاء الايف بنجاح ');
        }
      });
    }

    // try
    const handleSendMessage = () => {
      if (!messageText) {
        alert("يجب ملء كل الحقول");
        return;
      }

      socketRef.current.emit("sendMessage", {
        courseId: course._id,
        username: "admin",
        userNumber: "0",
        message: messageText,
        audioUrl: "",
      });

      setMessageText("");
    };
    

    // 25/8
    const fetchAllImages = async () => {
      senddata(`pdf/both/get_imgs/${course._id}`, {}, "GET").then((res) => {
        console.log(res.data)
        if (res.status === 200) setImageGroups(res.data);
        else alert("تعذر تحميل الصور");
      });
    };

    const uploadImageGroup = () => {
      if (!groupName || selectedImages.length === 0)
        return alert("ادخل اسم المجموعة وأضف الصور");

      const formData = new FormData();
      formData.append("group_name", groupName);
      formData.append("Course_Id", course._id);
      formData.append("Teacher_Name", course.Teachername || "مدرس"); // استبدل إذا كان اسم المدرس مخزن بطريقة أخرى
      formData.append("year", year);
      formData.append("lec", lec);
      selectedImages.forEach((img) => formData.append("files", img)); // لاحظ هنا: "files" بدل "images"

      sendFormData(`pdf/teacher/upload_images/${course._id}`, formData, "POST").then((res) => {
        if (res.status === 200) {
          alert("✅ تمت إضافة الصور بنجاح");
          setEnableAddImage(false);
          setSelectedImages([]);
          setGroupName("");
          fetchAllImages();
        } else alert("❌ فشل في الرفع");
      });
    };

    const deleteImageGroup = (id) => {
      if (!window.confirm("هل تريد حذف المجموعة كاملة؟")) return;
      senddata(`pdf/teacher/delete_img/${id}`, {}, "DELETE").then((res) => {
        if (res.status === 200) {
          alert("تم حذف المجموعة");
          fetchAllImages();
        }
      });
    };

    const deleteSpecificImage = (groupId, imgId) => {
      senddata(`pdf/teacher/delete_specific_image/${groupId}/${imgId}`, {}, "DELETE").then((res) => {
        if (res.status === 200) fetchAllImages();
      });
    };




  return (
    <div className=' bg-[#1A1A4C] text-white flex flex-col min-h-screen text-base font-semibold pb-40 '>
      {/* headers */}
      <div className='headers  '>
        <img src={logoimg} className='w-[70px] rounded-full mx-7 mt-2 ml-auto'/>
      </div>
      {/* course details */}
      <div className='flex flex-col items-center'>
                <h2 className='border-b-2 border-[#e9ad03]'>تفاصيل الكورس</h2>
                <div className=' grid grid-cols-1 rever gap-4 w-[70%] mt-6'>
                  {/* course.photo */}
                  <img src={course.photo} className='w-[full] mb-4 lg:w-[60%] lg:ml-[20%]' />
                  {/* <img src={test} className='w-[full] mb-4 lg:w-[60%] lg:ml-[20%]' /> */}
                </div>
                <div className='flex flex-row justify-between w-[60%] mt-2'>
                    {enableEdit?<input className=' bg-transparent border-b-2 border-[#e9ad03] focus:outline-none' value={title} onChange={(e)=>{setTitle(e.target.value)}} />:<p>{title}</p>}
                    <p>: الكورس</p>
                </div>
                <div className='flex flex-row justify-between w-[60%] mt-2'>
                    {enableEdit?<input className=' bg-transparent border-b-2 border-[#e9ad03] focus:outline-none' value={subject} onChange={(e)=>{setSubject(e.target.value)}} />:<p>{subject}</p>}
                    <p>: التصنيف</p>
                </div>
                <div className='flex flex-row justify-between w-[60%] mt-2'>
                    {enableEdit?<input className=' bg-transparent border-b-2 border-[#e9ad03] focus:outline-none' value={price} onChange={(e)=>{setPrice(e.target.value)}} />:<p>{price}</p>}
                    <p>: السعر</p>
                </div>
                <div className='flex flex-row justify-between w-[60%] mt-2'>
                    {enableEdit?
                    <select value={selectlevel} onChange={(event)=>{setSelectlevel(event.target.value);}} className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right ">
                      <option value="one-pre" className=' text-black'>اولي اعدادي</option>
                      <option value="two-pre" className=' text-black'>تانية اعدادي</option>
                      <option value="three-pre" className=' text-black'>تالتة اعدادي</option>
                      <option value="one-sec" className=' text-black'>اولي ثانوي</option>
                      <option value="two-sec" className=' text-black'>تانية ثانوي</option>
                      <option value="three-sec" className=' text-black'>تالتة ثانوي</option>
                    </select>
                    :<p>{level}</p>}
                    <p>: السنة</p>
                </div>
                {/* 25/7 */}
                <div className='flex flex-row justify-between w-[60%] mt-2'>
                  {enableEdit ? (
                    <select value={hide} onChange={(e) => setHide(e.target.value === "true")} className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right ">
                      <option value="false" className='text-black'>ظاهر</option>
                      <option value="true" className='text-black'>مخفي</option>
                    </select>
                  ) : (
                    <p>{hide ? "مخفي" : "ظاهر"}</p>
                  )}
                  <p>: حالة الظهور</p>
                </div>
                <div className='flex flex-row justify-between w-[60%] mt-2'>
                  {enableEdit ? (
                    <input type="number" min={0} value={availableTime} onChange={(e) => setAvailableTime(e.target.value)} className='bg-transparent border-b-2 border-[#e9ad03] focus:outline-none' />
                  ) : (
                    <p>{availableTime ? `${availableTime} يوم` : "دائم"}</p>
                  )}
                  <p>: مدة التوفر</p>
                </div>
    </div>
      <div className='grid grid-cols-2 gap-2 w-[70%] ml-auto mr-auto mt-10'>
          {enableEdit?<p onClick={saveInfo} className='px-7 py-1 bg-[#e9ad03] w-fit rounded-full cursor-pointer mr-auto' > حفظ</p>:<p></p>}
          <p onClick={()=>{setEnableEdit(!enableEdit)}} className='px-7 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer ml-auto'>{enableEdit?"عدم التعديل":"تعديل "}</p> 
      </div>

      {/* navigation */}
      <div dir='rtl' className='w-full overflow-x-auto scrollbar-hidden mt-20'>
        <div className='flex flex-row  py-2 min-w-full w-fit '>
          <p onClick={()=>{setShowOptions(1)}} className={`px-7 py-2 mb-4 w-fit rounded-full cursor-pointer mx-3 ${showOptions==1?"bg-[#eb0000]":"bg-[#e9ad03]"}`}> فيديوهات  </p> 
          <p onClick={()=>{setShowOptions(2)}} className={`px-7 py-2 mb-4 w-fit rounded-full cursor-pointer mx-3 ${showOptions==2?"bg-[#eb0000]":"bg-[#e9ad03]"}`}> أكواد </p> 
          <p onClick={()=>{setShowOptions(3)}} className={`px-7 py-2 mb-4 w-fit rounded-full cursor-pointer mx-3 ${showOptions==3?"bg-[#eb0000]":"bg-[#e9ad03]"}`}>  امتحانات </p> 
          <p onClick={()=>{setShowOptions(4)}} className={`px-7 py-2 mb-4 w-fit rounded-full cursor-pointer mx-3 ${showOptions==4?"bg-[#eb0000]":"bg-[#e9ad03]"}`}>  تدريبات </p> 
          <p onClick={()=>{setShowOptions(5)}} className={`px-7 py-2 mb-4 w-fit rounded-full cursor-pointer mx-3 ${showOptions==5?"bg-[#eb0000]":"bg-[#e9ad03]"}`}>  ملفات </p> 
          {/* 25/7 */}
          <p onClick={()=>{setShowOptions(6)}} className={`px-7 py-2 mb-4 w-fit rounded-full cursor-pointer mx-3 ${showOptions==6?"bg-[#eb0000]":"bg-[#e9ad03]"}`}>  الترتيب </p> 
          <p onClick={()=>{setShowOptions(7)}} className={`px-7 py-2 mb-4 w-fit rounded-full cursor-pointer mx-3 ${showOptions==7?"bg-[#eb0000]":"bg-[#e9ad03]"}`}>  لايف </p> 
        </div>
      </div>

      {/* videos */}
      {/* add video */}
      {showOptions==1&&<div className='w-[70%] ml-auto mr-auto mt-10'>
        <h2 className='border-b-2 border-[#e9ad03] mb-10 w-fit ml-auto mr-auto '>فيديوهات </h2>
        <p onClick={()=>{setEnableAddv(!enableAddv)}} className='px-7 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer ml-auto'>{enableAddv?"اغلاق":"اضافة فيديو "}</p> 
        {enableAddv&&
          <div className='border-2 border-[#e9ad03] rounded-2xl p-4 mt-4'>
            <div className=' grid grid-cols-1 rever gap-4'>
              <input 
                type="text"
                value={videoId}
                onChange={(e) => setVideoId(e.target.value)}
                className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
                placeholder='ال ID'
                />
            </div>
            <div className=' grid grid-cols-1 rever gap-4'>
               <input 
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
                  placeholder='العنوان'
                />
            </div>
            <div className=' grid grid-cols-2 rever gap-4'>
              <p onClick={addVideo} className='px-6 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer mt-6 '>اضافة </p>
              <select value={type} onChange={(event)=>{setType(event.target.value);}} className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-1 text-right ">
                <option value="free" className=' text-black'>مجاني</option>
                <option value="paid" className=' text-black'>اشتراك</option>
            </select>
            </div>
          </div>
          }
      </div>}
      {/* show videos */}
      {showOptions==1&&<div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5   gap-4 w-[70%] ml-[15%] '>
        {
        allVideos?.length&&
        <div className='mt-10'>
          {
            allVideos.map((video,key)=>{
              return(
                <div className='mb-10 border-2 border-[#e9ad03] rounded-xl p-2 '>
                   <div className="grid grid-cols-1 rever gap-4">
                    <iframe 
                      src={video.videoURL} 
                      style={{
                        width: '100%'
                      }}
                      allow="autoplay; fullscreen; picture-in-picture" 
                      allowFullScreen
                      title="Vimeo Video Player"
                    ></iframe>
                  </div>
                  <div className='p-3'>
                      <p className=' text-center text-[#e9ad03]'>{"الدرس"+" " +key} </p>
                      <p dir='rtl' > 👈 {video.description}</p>
                      <div className='flex justify-between items-center'>
                        <div className='flex '>
                          <p onClick={()=>{deleteVideo(video.id)}} className='mr-4 text-lg cursor-pointer'>🗑️</p>
                          {!enableEditv&&<p onClick={()=>{navigate("/video",{ state: {video,course} })}} className='mr-4 text-lg cursor-pointer'>🕵️‍♀️</p>}
                        </div>
                        <p>{video.type=="free"?"مجاني":"اشتراك"}</p>
                      </div>
                   </div>
                </div>
              )
            })
          }
        </div>
        }
      </div>}

      {/* codes */}

      {showOptions==2&&<div className='flex flex-col items-center mt-10 mb-40'>
        <h2 className='border-b-2 border-[#e9ad03] mb-5'>الأكواد </h2>
        <div className='flex flex-row justify-between w-[70%] mt-4'>
          <p className=' ml-[9%]'>{allCodes.length}</p>
          <p>: عدد الأكواد</p>
        </div>
        <div className='flex flex-row justify-between items-center w-[70%] mt-8'>
          <p onClick={createCodes} className='px-7 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer mr-auto hover:opacity-70'>{"اضافة "}</p> 
          <p>: اضف 10 اكواد</p>
        </div>
        <div className='flex flex-row justify-between items-center w-[70%] mt-8'>
          <p onClick={()=>{navigate("/printCodes",{ state: {allCodes,title:course.title} });}} className='px-4 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer mr-auto hover:opacity-70'>اذهب الي الطباعة</p> 
          <p>:  طباعة الأكواد </p>
        </div>
        <div className='flex flex-row justify-between items-center w-[70%] mt-8'>
          <p onClick={handleUsedCodes} className='px-4 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer mr-auto hover:opacity-70'> الأكواد المستخدمة </p> 
          <p>الأكواد المستخدمة </p>
        </div>
      </div>}

      {/* exams */}

      {showOptions==3&&<div className='flex flex-col items-center mt-10 mb-2'>
        <h2 className='border-b-2 border-[#e9ad03] mb-5'>امتحانات </h2>

        <div className='flex flex-row justify-between items-center w-[70%] mt-8'>
          <p onClick={habdleExercise} className='px-7 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer mr-auto hover:opacity-70'>{"اضافة "}</p> 
          <p>: امتحان جديد</p>
        </div>
        <div className='flex flex-row justify-between items-center w-[70%] mt-8'>
          <p> </p> 
          <p>: امتحانات سابقة </p>
        </div>
        {/* <div className='flex flex-row justify-between items-center w-[70%] mt-8'>
          <p onClick={()=>{navigate("/printCodes",{ state: {allCodes,title:course.title,Teachername:course.Teachername } });}} className='px-4 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer mr-auto hover:opacity-70'>اذهب الي الطباعة</p> 
          <p>:  طباعة الأكواد </p>
        </div>
        <div className='flex flex-row justify-between items-center w-[70%] mt-8'>
          <p className='px-4 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer mr-auto hover:opacity-70'> الأكواد المستخدمة </p> 
          <p>الأكواد المستخدمة </p>
        </div> */}
      </div>}

      {showOptions==3&&<div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5   gap-4 w-[70%] ml-[15%] '>
        {
        allExams?.length&&
        <div className='mt-11'>
          {
            allExams.map((exam,key)=>{
              return(
                <div className='mb-10 border-2 border-[#e9ad03] rounded-xl p-2 '>
                   <div className="grid grid-cols-1 rever gap-4">
                   <p className=' text-center text-[#e9ad03]'>{" " +key+1} </p>
                   <p dir='rtl' > 👈 {exam.title}</p>
                  </div>
                  <div className='p-3'>
                      <div className='flex justify-between items-center'>
                        <div className='flex '>
                          {/* pdf==url */}
                          <p onClick={()=>{deleteExam(exam)}} className='mr-4 text-lg cursor-pointer'>🗑️</p>
                          <p onClick={()=>{navigate("/exam",{ state: exam });}} className='mr-4 text-lg cursor-pointer'>🔎</p>
                        </div>
                      </div>
                   </div>
                </div>
              )
            })
          }
        </div>
        }
      </div>}


      {showOptions==5&&<div className='w-[70%] ml-auto mr-auto mt-10'>
        <h2 className='border-b-2 border-[#e9ad03] mb-10 w-fit ml-auto mr-auto '>ملفات  </h2>
        <p onClick={()=>{setEnableAddf(!enableAddf)}} className='px-7 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer ml-auto'>{enableAddf?"اغلاق":"اضافة ملف "}</p> 
        {enableAddf&&
          <div className='border-2 border-[#e9ad03] rounded-2xl p-4 mt-4'>
            {file&&<p>{file.name}</p>}
            <div className=' grid grid-cols-1 rever gap-4'>
              <input 
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
                placeholder='الاسم'
                />
            </div>
            <div className='h-full flex items-end justify-between'>
              <p onClick={addFile} className='px-6 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer mt-6 '>اضافة </p>
              <p dir='rtl' onClick={()=>{if(!file) {fileInputRef.current.click()} else{ setFile(""); fileInputRef.current.value = "";  }   }} className= {`px-6 py-1 ${!file?"bg-[#e9ad03]":" bg-[#da0000]"} w-fit rounded-full cursor-pointer mt-6 ` }>{!file ? "اختر pdf" : "حذف pdf"} </p>
            <input 
                type="file"
                accept="*"
                ref={fileInputRef}
                onChange={handleFileChange}
                className="hidden"
                />
            </div>
          </div>
          }
      </div>}
      {showOptions==5&&<div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5   gap-4 w-[70%] ml-[15%] '>
        {
        allFiles?.length&&
        <div className='mt-10'>
          {
            allFiles.map((file,key)=>{
              return(
                <div className='mb-10 border-2 border-[#e9ad03] rounded-xl p-2 '>
                   <div className="grid grid-cols-1 rever gap-4">
                   <p className=' text-center text-[#e9ad03]'>{" " +key+1} </p>
                   <p dir='rtl' > 👈 {file.name}</p>
                  </div>
                  <div className='p-3'>
                      <div className='flex justify-between items-center'>
                        <div className='flex '>
                          {/* pdf==url */}
                          <p onClick={()=>{deletePdf(file)}} className='mr-4 text-lg cursor-pointer'>🗑️</p>
                          <p onClick={()=>{openPdf(file)}} className='mr-4 text-lg cursor-pointer'>📭</p>
                        </div>
                      </div>
                   </div>
                </div>
              )
            })
          }
        </div>
        }
      </div>}
      {/* 25/8 */}
      {/* images */}
      {showOptions == 5 && (
        <div className='w-[70%] ml-auto mr-auto mt-10'>
          <h2 className='border-b-2 border-[#e9ad03] mb-10 w-fit ml-auto mr-auto '>صور</h2>
          <p
            onClick={() => setEnableAddImage(!enableAddImage)}
            className='px-7 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer ml-auto'
          >
            {enableAddImage ? 'اغلاق' : 'اضافة مجموعة صور'}
          </p>

          {enableAddImage && (
            <div className='border-2 border-[#e9ad03] rounded-2xl p-4 mt-4'>
              <div className='grid grid-cols-1 gap-4'>
                <input
                  type='text'
                  value={groupName}
                  onChange={(e) => setGroupName(e.target.value)}
                  className='bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right'
                  placeholder='اسم المجموعة'
                />
                <input
                  multiple
                  accept='image/*'
                  type='file'
                  ref={imageInputRef}
                  onChange={(e) => setSelectedImages([...e.target.files])}
                  className='border p-2'
                />
                {selectedImages.length > 0 && (
                  <div className='grid grid-cols-2 gap-2'>
                    {selectedImages.map((img, i) => (
                      <img key={i} src={URL.createObjectURL(img)} className='w-full h-40 object-cover rounded' />
                    ))}
                  </div>
                )}
              </div>
              <div className='flex justify-between mt-6'>
                <p onClick={uploadImageGroup} className='px-6 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer'>اضافة</p>
                <p
                  onClick={() => {
                    setSelectedImages([]);
                    imageInputRef.current.value = '';
                  }}
                  className='px-6 py-1 bg-[#e9ad03] w-fit rounded-full cursor-pointer'
                >
                  مسح الصور
                </p>
              </div>
            </div>
          )}
        </div>
      )}

      {showOptions == 5 && (
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 w-[70%] ml-[15%]'>
          {imageGroups.length > 0 &&
            imageGroups.map((group) => (
              <div key={group._id} className='mb-10 border-2 border-[#e9ad03] rounded-xl p-2'>
                <p className='text-center text-[#e9ad03] font-bold'>📁 {group.group_name}</p>
                <div className='grid grid-cols-2 gap-2 mt-3'>
                  {group.images.map((img) => (
                    <div key={img._id} className='relative'>
                      <img src={`${img.url}`} className='w-full h-32 object-cover rounded' />
                      <p
                        onClick={() => deleteSpecificImage(group._id, img._id)}
                        className='absolute top-1 right-1 bg-red-600 text-white p-1 rounded cursor-pointer text-sm'
                      >
                        🗑️
                      </p>
                    </div>
                  ))}
                </div>
                <div className='mt-2 flex justify-between items-center'>
                  <p className='text-sm'>👨‍🏫 {group.Teacher_Name}</p>
                  <p onClick={() => deleteImageGroup(group._id)} className='text-red-600 text-xl cursor-pointer'>
                    🗑️
                  </p>
                </div>
              </div>
            ))}
        </div>
      )}

        {/* 25/7 */}
      {/* scores */}

      {showOptions==6&&
      <div className='w-full overflow-x-auto scrollbar-hidden px-6 mt-8 '>
        <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' > 
            <div className='text-base w-[50px] text-center'>الترتيب</div>
            <div className='text-base w-[150px] text-center'>الاسم</div>
            <div className='text-base w-[100px] text-center'>النقاط</div>
         </div>
         {allStudentScore?.map((score,index) => (
            <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' key={score.student.id}> 
                <div className='text-base w-[100px] text-center'>{(index+1)}</div>
                <div className='text-base w-[150px] text-center'>
                    {score?.student?.FirstName + ' ' + score?.student?.LastName}</div>
                <div className='text-base w-[100px] text-center'>{score?.score}</div>
             </div>
           ))}
      </div>
      }

      {showOptions==7&&<div className='w-[70%] ml-auto mr-auto mt-10'>
        <h2 className='border-b-2 border-[#e9ad03] mb-10 w-fit ml-auto mr-auto '>لايف  </h2>
          <div className='border-2 border-[#e9ad03] rounded-2xl p-4 mt-4'>
            <div className=' grid grid-cols-1 rever gap-4'>
              <input 
                type="text"
                value={liveVideo}
                onChange={(e) => setLiveVideo(e.target.value)}
                className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
                placeholder='اللينك'
                />
            </div>
            <p onClick={addLive} className='px-6 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer mt-6 '>اضافة </p>
          </div>
          <p onClick={deleteLive} className='px-6 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer mt-6 '>انهاء اللايف </p>
      </div>
      }
      {showOptions==7&&<div className='w-[80%] ml-auto mr-auto mt-10'>
        <h2 className='text-[#e9ad03] text-xl text-center mb-6'>الرسائل الحالية</h2>
        {liveMessages?.length === 0 && <p className='text-center'>لا توجد رسائل حتى الآن</p>}
        {liveMessages.map((msg, index) => (
          <div key={msg.id} className="flex justify-between items-center bg-[#2e2e6a] p-3 rounded-xl mb-3">
            <div>
              <p className='text-sm text-[#e9ad03]'>{msg.username}  {msg.userNumber}</p>
              {msg.message && <p className='text-white'>{msg.message}</p>}
              {msg.audioUrl && (
                <audio controls className="mt-2">
                  <source src={msg.audioUrl} type="audio/webm" />
                  متصفحك لا يدعم تشغيل الصوت
                </audio>
              )}
            </div>
            <button onClick={() => deleteMessage(msg.id)} className="text-red-500 text-xl hover:opacity-70">🗑️</button>
          </div>
        ))}
      </div>}
      {showOptions == 7 &&
        <div className="w-[80%] ml-auto mr-auto mt-10">
          <h2 className='text-[#e9ad03] text-xl text-center mb-6'>ارسال رسالة جديدة</h2>
          <div className='flex flex-col gap-3 bg-[#2e2e6a] p-4 rounded-xl'>
            <textarea
              placeholder="اكتب الرسالة هنا"
              className="bg-transparent border-2 border-[#e9ad03] text-white focus:outline-none p-2 h-24"
              onChange={(e) => setMessageText(e.target.value)}
              value={messageText}
            />
            <div className="flex items-center gap-4">
              <button onClick={handleSendMessage} className="px-6 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer">📤 ارسال</button>
            </div>
          </div>
        </div>
      }

      

    </div>
  )
}

export default Course
